import { FUNCTIONAL_ELEMENT_TYPE, FunctionalElement } from './functional-element';

export type MaterialSerialNumber = Readonly<{
    materialLabel: string;
    materialXmlId: string;
    materialValue: string;
    serialLabel: string;
    serialXmlId: string;
    serialValue: string;
    descriptionLabel: string; // only in astoria
    descriptionXmlId: string; // only in astoria
    descriptionValue: string; // only in astoria
    description?: string; // only in cosima
    type:
        | FUNCTIONAL_ELEMENT_TYPE.MATERIAL_SERIAL_NO
        | FUNCTIONAL_ELEMENT_TYPE.MATERIAL_SERIAL_NO_WITH_DESC
        | FUNCTIONAL_ELEMENT_TYPE.COMPONENT;
}> &
    FunctionalElement;

export const initialMaterialSerialNumberState: MaterialSerialNumber = {
    id: -1,
    materialLabel: '',
    materialXmlId: '',
    materialValue: '',
    parentId: -1,
    serialLabel: '',
    serialXmlId: '',
    serialValue: '',
    descriptionLabel: '',
    descriptionXmlId: '',
    descriptionValue: '',
    type: FUNCTIONAL_ELEMENT_TYPE.MATERIAL_SERIAL_NO,
    controllingCheckpoint: '',
    contentLoadedFromXml: false,
    disabled: false,
    controllingOption: undefined,
    uniqueId: undefined,
};

export function isMaterialSerialNumber(f: FunctionalElement): f is MaterialSerialNumber {
    return (
        f.type === FUNCTIONAL_ELEMENT_TYPE.MATERIAL_SERIAL_NO ||
        f.type === FUNCTIONAL_ELEMENT_TYPE.MATERIAL_SERIAL_NO_WITH_DESC ||
        f.type === FUNCTIONAL_ELEMENT_TYPE.COMPONENT
    );
}
